import { Routes, Route } from "react-router-dom";
import { ShopAuthProvider } from "@/lib/shopAuth";
import ShopHome from "./ShopHome";
import PublicGallery from "@/pages/PublicGallery";
import ShopProduct from "./ShopProduct";
import ShopCart from "./ShopCart";
import ShopCheckout from "./ShopCheckout";
import ShopPaymentResult from "./ShopPaymentResult";
import Legal from "./Legal";
import ShopAuth from "./ShopAuth";
import ShopVerify from "./ShopVerify";
import ShopReset from "./ShopReset";
import ShopAccount from "./ShopAccount";
import MyStore from "./b2b/MyStore";
import MyStoreProduct from "./b2b/MyStoreProduct";
import MyStoreCart from "./b2b/MyStoreCart";
import MyStoreOrders from "./b2b/MyStoreOrders";

export default function ShopApp() {
  return (
    <ShopAuthProvider>
      <Routes>
        <Route path="/" element={<ShopHome />} />
        <Route path="/realizacje" element={<PublicGallery embedded />} />
        <Route path="/produkt/:id" element={<ShopProduct />} />
        <Route path="/koszyk" element={<ShopCart />} />
        <Route path="/zamowienie" element={<ShopCheckout />} />
        <Route path="/platnosc" element={<ShopPaymentResult />} />
        <Route path="/logowanie" element={<ShopAuth />} />
        <Route path="/konto" element={<ShopAccount />} />
        <Route path="/moj-sklep" element={<MyStore />} />
        <Route path="/moj-sklep/produkt/:pid" element={<MyStoreProduct />} />
        <Route path="/moj-sklep/koszyk" element={<MyStoreCart />} />
        <Route path="/moj-sklep/zamowienia" element={<MyStoreOrders />} />
        <Route path="/weryfikacja" element={<ShopVerify />} />
        <Route path="/reset-hasla" element={<ShopReset />} />
        <Route path="/regulamin" element={<Legal doc="regulamin" />} />
        <Route path="/polityka-prywatnosci" element={<Legal doc="polityka-prywatnosci" />} />
        <Route path="/odstapienie" element={<Legal doc="odstapienie" />} />
      </Routes>
    </ShopAuthProvider>
  );
}
